import Head from 'next/head'
import React from 'react'

import { Download } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../lib/analytics'
import { bulkOrderCategory } from '../constants'
import { useTranslatedStyleGuide } from '../hooks/useTranslatedStyleGuide'
import { CollectionViewHeroSection } from '../types'

import {
  BulkAlert,
  BulkAlertMessage,
  Description,
  DownloadText,
  DownloadWrapper,
  HeroContent,
  HeroContentInner,
  HeroImageWrapper,
  HeroWrapper,
  ResponsiveHeroImage,
  Title,
} from './styles'

type Props = { data: CollectionViewHeroSection }

export const BulkHero: React.FC<Props> = ({ data }) => {
  const {
    bulk: { alertCta, styleGuideDownloadCta, header },
  } = useTranslation()
  const downloadUrl = useTranslatedStyleGuide()

  const { title, subtitle, imageDesktop } = data

  return (
    <HeroWrapper aria-label={header}>
      {imageDesktop && (
        <HeroImageWrapper>
          <ResponsiveHeroImage
            src={imageDesktop}
            alt=''
            loading='lazy'
            aspectRatios={{
              sm: 1,
              md: 1,
            }}
            fetchPriority='high'
            widths={{ unit: 'vw', sm: 100, md: 100 }}
            renderPreloadLink={preloadLink => <Head>{preloadLink}</Head>}
          />
        </HeroImageWrapper>
      )}

      <HeroContent>
        <HeroContentInner>
          <Title>{title}</Title>
          <Description>{subtitle}</Description>
          <DownloadWrapper
            href={downloadUrl}
            target='_blank'
            {...trackEvent({ category: bulkOrderCategory, action: 'download style guide' })}
          >
            <Download />
            <DownloadText>{styleGuideDownloadCta}</DownloadText>
          </DownloadWrapper>
          <BulkAlert>
            <BulkAlertMessage>{alertCta}</BulkAlertMessage>
          </BulkAlert>
        </HeroContentInner>
      </HeroContent>
    </HeroWrapper>
  )
}
